module.exports = __webpack_public_path__ + "media/services/smart-manage-70d10a2e.svg";